import { useMemo, useState } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { AttendanceLocal } from "../../../../../../../../../../../@types/attendance-local";
import { DepartmentAvailable } from "../../../../../../../../../../../@types/attendance-local-department";
import { useDepartmentAvailableList } from "../../../../../../../../../../../services/api-tansquery/department-available-list";

type Props = {
    slug: AttendanceLocal["slug_unidade"];
    field: ControllerRenderProps<{
        misto?: boolean;
        setor_id?: {
            id?: number;
            nome?: string;
        };
        ativo?: boolean;
    }, "setor_id">
    fieldState: ControllerFieldState
    style?: React.CSSProperties;
}

export default function DepartmentField({ slug, field, fieldState, style }: Props) {
    const [search, setSearch] = useState<string>();
    const { data: departmentsList, isLoading } = useDepartmentAvailableList({
        search, unidade: slug, page: 1
    });

    const options = useMemo(() => {
        return departmentsList?.results || [];
    }, [departmentsList]);

    const selected = useMemo(() => {
        return departmentsList?.results.find(
            (department) => department.id === field.value?.id
        ) || null;
    }, [departmentsList, field.value]);

    function handleInputChange(_, value: string, reason: string) {
        if (reason === "input") {
            setSearch(value.trim() === "" ? undefined : value);
        }
    }

    function handleChange(_, newValue: DepartmentAvailable | null) {
        if (!newValue) {
            field.onChange(null);
        } else {
            field.onChange(newValue);
        }
    }

    return (
        <Autocomplete
            style={style}
            freeSolo={false}
            options={options}
            value={selected}
            onChange={handleChange}
            onInputChange={handleInputChange}
            getOptionLabel={(option) => option.nome || ""}
            getOptionSelected={(option, value) => option.id === value.id}
            loading={isLoading}
            loadingText="Carregando setor..."
            noOptionsText="Nenhum setor encontrado"
            renderInput={(params) => (
                <TextField
                    {...params}
                    required
                    label="Setor"
                    variant="outlined"
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message || "Selecione um setor"}
                    InputProps={{
                        ...params.InputProps,
                        required: false,
                        endAdornment: (
                            <>
                                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
}
